import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { RouterLink } from '@/components/functional/Link/RouterLink';
import { CaseListItemBase } from '@/components/modules/pages/case/list/CaseList/CaseListItemBase';
import { TopBaseSliderItem } from '@/components/modules/pages/top/slider/TopBaseSlider';
import { caseOnePath } from '@/utils/router/links';
/**
 * TOP: 選定事例のスライダー項目
 * @param props
 * @returns
 */
export const TopCaseSliderItem = (props) => {
    const { category, className = '', client, description, id, price, title, } = props;
    return (_jsx(TopBaseSliderItem, { children: _jsx(RouterLink, Object.assign({ to: caseOnePath(`${id}`) }, { children: _jsx(CaseListItemBase, { category: category, className: clsx('pt-28 lg:pt-20 px-[30px] pb-24 lg:pb-[30px]', 'h-[360px] xs:h-[342px] lg:h-[356px]', className), client: client, customClassName: {
                    head: 'h-[48px]',
                }, description: description, price: price, title: title }) })) }));
};
